import { UnreachableCaseError } from "libs/errors";
import { PointerWithRecord } from "libs/schema";
import { useMemo } from "react";
import { IListOnEntryActionEvent, IListRef } from "~/components/list";
import { ClientEnvironment } from "~/environment/ClientEnvironment";
import { isModKeyActive } from "~/environment/command.service";
import { IThreadViewContext } from "../thread/context";

export type TTrashEntry = PointerWithRecord<"thread">;

/* -----------------------------------------------------------------------------------------------*/

export async function onTrashEntrySelect(
  environment: Pick<ClientEnvironment, "router">,
  props: {
    event: IListOnEntryActionEvent<TTrashEntry>;
  },
) {
  const { event } = props;

  switch (event.entry.table) {
    case "thread": {
      return environment.router.navigate(`/trash/threads/${event.entry.record.id}`, {
        openInNewTab: isModKeyActive(event.event),
      });
    }
    default: {
      throw new UnreachableCaseError(event.entry.table);
    }
  }
}

/* -----------------------------------------------------------------------------------------------*/

export function useTrashViewThreadContext(props: { listRef: React.RefObject<IListRef<TTrashEntry>> }) {
  const { listRef } = props;

  return useMemo((): IThreadViewContext => {
    return { threadList: { type: "trash", ref: listRef } };
  }, [listRef]);
}

/* -----------------------------------------------------------------------------------------------*/
